/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  UserProfile
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Record that the caller has seen the welcome tour, and return the profile.
 *
 * Idempotent, and deliberately so: the tour can be closed by Skip, by the
 * last page's button, by Escape or by clicking outside it, and a slow network
 * can deliver two of those. Only the FIRST dismissal is kept — a second one
 * leaves the timestamp alone, so the column answers "when did they first see
 * it" rather than "when did they last close something".
 *
 * Anyone may call it, admin or not. A member has nothing to be shown, and
 * refusing them would turn a harmless write into an error the UI has to
 * handle for no benefit.
 *
 * Returns the profile so the client can drop the flag from its cache in the
 * same round trip, rather than refetching to learn what it just did.
 * @summary Mark Welcome Tour Seen
 */
export const markWelcomeTourSeen = (

 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<UserProfile>(
      {url: `/user/welcome-tour/seen`, method: 'POST', signal
    },
      options);
    }




export const getMarkWelcomeTourSeenMutationKey = () => ['markWelcomeTourSeen'] as const;

export const getMarkWelcomeTourSeenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markWelcomeTourSeen>>, TError,void, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof markWelcomeTourSeen>>, TError,void, TContext> => {

const mutationKey = getMarkWelcomeTourSeenMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markWelcomeTourSeen>>, void> = () => {


          return  markWelcomeTourSeen(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkWelcomeTourSeenMutationResult = NonNullable<Awaited<ReturnType<typeof markWelcomeTourSeen>>>

    export type MarkWelcomeTourSeenMutationError = unknown


    /**
 * @summary Mark Welcome Tour Seen
 */
export const useMarkWelcomeTourSeen = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markWelcomeTourSeen>>, TError,void, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markWelcomeTourSeen>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMarkWelcomeTourSeenMutationOptions(options));
    }
